module.exports = __webpack_public_path__ + "static/img/news-top-imgM.12dafd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-top-imgM.png
// module id = XewN
// module chunks = 1